import { SxProps, Theme } from '@mui/material';
import { Column } from 'src/components/table';
import { lang } from 'src/utils';

export const MULTIPLE_LOCATION_GROUPS_TABLE_COLUMNS: Column[] = [
  {
    id: 'actions',
    align: 'left',
    width: '4%',
  },
  {
    id: 'name',
    label: lang.locationGroup,
    width: '34%',
  },
  {
    id: 'daypart',
    label: lang.daypart,
    width: '14%',
  },
  {
    id: 'defaultAssembly',
    label: lang.defaultAssembly,
    width: '40%',
  },
  {
    id: 'preview',
    align: 'right',
    width: '12%',
  },
];

export const SINGLE_LOCATION_GROUP_TABLE_COLUMNS: Column[] = [
  {
    id: 'nsn',
    label: lang.nsn,
    width: '25%',
  },
  {
    id: 'daypart',
    label: lang.daypart,
    width: 'auto',
  },
  {
    id: 'position',
    label: lang.position,
    width: 'auto',
  },
  {
    id: 'defaultAssembly',
    label: lang.defaultAssembly,
    width: '40%',
  },
];

export const EXPANDED_ROW_COLUMNS: Column[] = [
  {
    id: '',
    label: '',
    width: '5%',
  },
  {
    id: 'nsn',
    label: lang.nsn,
    width: '35%',
  },
  {
    id: 'position',
    label: lang.position,
    width: 'auto',
  },
];

export const REVIEW_TABLE_HEIGHT = '55vh';

export const EXPORT_HEADERS = [
  { label: lang.locationGroup, key: 'name' },
  { label: lang.daypart, key: 'daypart' },
  { label: lang.defaultAssembly, key: 'defaultAssembly' },
  { label: lang.scheduleComponent.scheduleNameField, key: 'scheduleName' },
  { label: lang.position, key: 'position' },
  { label: lang.components, key: 'components' },
];

export const MAIN_TABLE_TITLE_STYLES: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 'bold',
  wordBreak: 'break-word',
};

export const COLLAPSE_TABLE_TITLE_STYLES: SxProps<Theme> = {
  backgroundColor: 'rgba(2, 90, 197, 0.04)',
  fontSize: '14px',
  fontWeight: 'bold',
  cursor: 'default',
};

export const COLLAPSE_TABLE_BODY_STYLES: SxProps<Theme> = {
  backgroundColor: 'rgba(2, 90, 197, 0.04)',
  fontSize: '14px',
  fontWeight: 400,
  cursor: 'default',
  ':hover': {
    backgroundColor: 'rgba(2, 90, 197, 0.04)',
  },
};
